import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../helper/BaseUrl";

const ProtectedRoute = ({ children }) => {
  const [isValid, setIsValid] = useState(null);
  useEffect(() => {
    let interval;

    const verifyUser = async (forcePasswordCheck = false) => {
      try {
        const token = sessionStorage.getItem("AccessTokenTms");
        if (!token) {
          setIsValid(false);
          return;
        }

        await axios.get(`${BaseUrl}api/rbac/my-permissions`, {
          withCredentials: true,
          headers: {
            "x-access-token": token,
            "x-force-password-check": forcePasswordCheck ? "1" : "0",
          },
        });

        setIsValid(true);
      } catch (error) {
        const status = error.response?.status;
        if (status === 401 || status === 403) {
          sessionStorage.removeItem("AccessTokenTms");
          setIsValid(false);
          return;
        }
        setIsValid(true);
      }
    };

    // A fresh page load must invalidate an old password session immediately.
    verifyUser(true);

    // An already-open page keeps the requested 10-minute grace period. The
    // backend rejects the first heartbeat after that deadline.
    interval = setInterval(() => verifyUser(false), 10000);

    // 👉 Cleanup (VERY IMPORTANT)
    return () => {
      if (interval) clearInterval(interval);
    };
  }, []);

  // ⏳ While checking
  if (isValid === null) {
    return <div>Loading...</div>;
  }

  // ❌ Not valid → redirect
  if (!isValid) {
    return <Navigate to="/login" />;
  }

  // ✅ Valid
  return children;
};

export default ProtectedRoute;
